import React, { useEffect, useState } from 'react';
import useApp from 'hooks/useApp'
import { Button } from 'components'

const DataConnectionError = () => {

	const App = useApp()
	const [errorOpen, setErrorOpen] = useState(false)

	const openError = () => {
		setErrorOpen(!errorOpen)
	}

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="flex_1 padding center-cont">
				<i className="icon icon_error_tri" />
				<h3 className="intro-tit mt_20">정보수집 오류가 발생했어요.</h3>
				<span className="intro-sub-tit mt_10">다시 시도해주세요.</span>
				<div className={`error-box ${errorOpen ? "active" : ""} mt_20`} onClick={openError}>
					<div className="title">
						<p>error_code_404</p>
						<i className="icon icon_arrow_sm bottom" />
					</div>
					<div className="contents">
						<hr className="my_20" />
						<div>
							에러 내용
						</div>
					</div>
				</div>
			</div>
			<div className="flex-shrink_0 padding">
				<Button className="btn btn--big">확인</Button>
			</div>
		</div>
	)
}

export default DataConnectionError